import React, { useState, useRef } from "react";
import {
  Button,
  ClickAwayListener,
  MenuList,
  Paper,
  Popper,
  Tooltip,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Grow from "@mui/material/Grow";
import DeleteModal from "../DeleteModal/DeleteModal";
import { useNavigate } from "react-router-dom";
import "./MultiplePoppers.css";
import { useDispatch, useSelector } from "react-redux";
import { handleDeleteButton } from "../../HandleSlice/HandleSlice";
import axios from "axios";
import { INTERNAL_PATHS } from "../../configs/routes.config";
import { API_BASE_URL } from "../../configs/variable.config";
import { Toastify } from "../../utils/function.utils";

const MultiplePoppers = (props) => {
  const {
    itemId,
    popperListData,
    fetchInputsData,
    location,
    setIsCheck,
    item,
  } = props;

  const [poppers, setPoppers] = useState([
    { id: 1, anchorEl: null, open: false },
  ]);
  const [popupDisplay, setPopupDisplay] = useState("invisible opacity-0");
  const [deleteEvent, setDeleteEvent] = useState();
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const dispatch = useDispatch();
  const stateManager = useSelector((state) => state);

  const handleClick = (index, event) => {
    for (let itemId of stateManager.hamberger.deleteButonId) {
      if (itemId === event.currentTarget.id) {
        return;
      }
    }

    const newPoppers = [...poppers];
    newPoppers[index].anchorEl = event.currentTarget;
    newPoppers[index].open = !newPoppers[index].open;
    setPoppers(newPoppers);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    } else setPoppers([{ id: 1, anchorEl: null, open: false }]);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setPoppers([{ id: 1, anchorEl: null, open: false }]);
    } else if (event.key === "Escape") {
      setPoppers([{ id: 1, anchorEl: null, open: false }]);
    }
  }

  const settingClickHandler = (e, route) => {
    if (e.currentTarget.getAttribute("key_value") === "remove") {
      setPopupDisplay("visible opacity-100");
      setDeleteEvent(e.currentTarget);
      let idArray = [];
      idArray.push(e.currentTarget.getAttribute("data_id"));
      dispatch(handleDeleteButton(idArray));
    } else if (e.currentTarget.getAttribute("key_value") === "edit") {
      const dataId = e.currentTarget.getAttribute("data_id");
      // const splitId = +dataId.split("-")[1];
      navigate(`/${props.location}/edit/${dataId}`);
    } else if (e.currentTarget.getAttribute("key_value") === "url") {
      const dataId = e.currentTarget.getAttribute("data_id");
      // const splitId = +dataId.split("-")[1];
      localStorage.setItem("prevRoute", location);
      navigate(`/${route}edit/${dataId}?loc=url`);
    } else if (e.currentTarget.getAttribute("key_value") === "restore") {
      const dataId = e.currentTarget.getAttribute("data_id");
      // const splitId = +dataId.split("-")[1];
      // console.log(splitId);
      axios(`${API_BASE_URL}${INTERNAL_PATHS.MAGSRESTORE}/${dataId}`)
        .then((response) => {
          Toastify("success", response.data.message);
          props.fetchInputsData();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  return (
    <>
      {poppers.map((popper, index) => (
        <div key={popper.id} className="w-30 h-10">
          <Tooltip title={"تنظیمات"} placement="top" arrow>
            <Button
              ref={anchorRef}
              id={`${itemId}`}
              aria-controls={popper.open ? "composition-menu" : undefined}
              aria-expanded={popper.open ? "true" : undefined}
              aria-haspopup="true"
              aria-describedby={itemId}
              onClick={(event) => handleClick(index, event)}
            >
              <i
                className={`fa fa-bars p-4 hover:bg-stone-200 hover:p-4 hover:rounded-full cursor-pointer transition-all ${
                  popper.open ? "rotate-90" : "rotate-0"
                }`}
              ></i>
            </Button>
          </Tooltip>

          <Popper
            open={popper.open}
            id={itemId}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom-start" ? "left top" : "left bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={popper.open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      onKeyDown={handleListKeyDown}
                      sx={{ backgroundColor: "#000000" }}
                    >
                      <h3 className="text-[12px] mr-2 font-bold text-right">
                        تنظیمات
                      </h3>
                      {popperListData &&
                        popperListData.map((item3) => (
                          <div
                            className="flex items-center hover:bg-stone-200 w-full ml-2 h-[40px] gap-1 text-[13px]"
                            key={item3.key}
                            key_value={item3.key}
                            data_id={`${itemId}`}
                            onClick={(e) => settingClickHandler(e, item3.url)}
                          >
                            <MenuItem onClick={handleClose}>
                              <div className="flex justify-start gap-2">
                                <i
                                  className={`mr-2 pt-[1px] fa fa-${item3.icon}`}
                                ></i>
                                <span className="w-full h-full flex items-center text-[13px]">
                                  {item3.label}
                                </span>
                              </div>
                            </MenuItem>
                          </div>
                        ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
          <DeleteModal
            popupDisplay={popupDisplay}
            setPopupDisplay={setPopupDisplay}
            deleteEvent={deleteEvent}
            fetchInputsData={fetchInputsData}
            location={location}
            setIsCheck={setIsCheck}
            item={item}
          />
        </div>
      ))}
    </>
  );
};

export default MultiplePoppers;
